import { createSlice } from '@reduxjs/toolkit';
import { generateReduxKeys } from '../../utils';

const initialState = generateReduxKeys({
  labels: [],
});

const testSlice = createSlice({
  name: 'labels',
  initialState,
  reducers: {
    setLabels: (state, action) => {
      localStorage.setItem('labels', JSON.stringify(state.labels));
      state.labels = action.payload;
    },
  },
});

export const { setLabels } = testSlice.actions;

export default testSlice.reducer;
